import { getAllTags } from '@/api'
import type { Tag } from '@/types'
import { useAsyncState } from '@vueuse/core'
import { acceptHMRUpdate, defineStore } from 'pinia'

export const useTagStore = defineStore('tags', function () {
    const { state: tags } = useAsyncState(getAllTags(), [])
    async function getTags() {
        tags.value = await getAllTags()
    }
    function getTagFromId(id: number): Tag | undefined {
        return tags.value.find((x) => x.id == id)
    }
    function getTagFromName(name: string): Tag | undefined {
        return tags.value.find((x) => x.name == name)
    }
    getTags()
    return { tags, getTags, getTagFromId, getTagFromName }
})
// make sure to pass the right store definition, `useAuth` in this case.
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useTagStore, import.meta.hot))
}
